import { PROJECT_STATUSES } from '@/models/projectStatus';
import { ProjectsState } from './projects.types';

export { PROJECT_STATUSES } from '@/models/projectStatus';

/** Statuses meaning the project is not ready yet - the backend is still working on it. */
export const PROCESSING_STATUSES: string[] = [
  PROJECT_STATUSES.UNKNOWN,
  PROJECT_STATUSES.PARSING_DATA,
  PROJECT_STATUSES.UPLOADING_TO_DB,
];

export const EMPTY_ARRAY_LENGTH = 0;
export const PROJECTS_FETCHING_ERROR_PREFIX = 'Error fetching projects';
export const PROJECT_REMOVAL_ERROR_PREFIX = 'Error removing project: ';

export const PROJECTS_INITIAL_STATE: ProjectsState = {
  data: [],
  loading: 'idle',
  error: { name: '', message: '' },
};
